import React from 'react'

const isFullUrl = (url) => typeof url === 'string' && /^https?:\/\//i.test(url)

// helpers for checking full URL

const normalize = (val) => {
  if (!val) return null
  if (typeof val === 'string') {
    if (isFullUrl(val)) return val
    // if string without protocol, try to prefix with API URL if provided
    if (val.startsWith('/')) return (process.env.REACT_APP_API_URL || '') + val
    return val
  }
  if (Array.isArray(val) && val.length) return normalize(val[0])
  if (val && typeof val === 'object') {
    if (typeof val.url === 'string') return normalize(val.url)
    if (typeof val.path === 'string') return normalize(val.path)
  }
  return null
}

export function RemoteImg({ src, alt = '', className, style }){
  let url = normalize(src)
  // route R2 links through backend proxy to avoid CORS / public issues
  if (url && url.includes('.r2.cloudflarestorage.com')) {
    const proxyBase = process.env.REACT_APP_API_URL || ''
    url = `${proxyBase.replace(/\/$/, '')}/media/proxy?url=${encodeURIComponent(url)}`
  }
  const [error, setError] = React.useState(false)

  if (!url || error) {
    return <div className={className} style={{...style, backgroundColor: '#f3f4f6'}} aria-hidden />
  }

  return (
    <img
      src={url}
      alt={alt}
      className={className}
      style={style}
      crossOrigin="anonymous"
      onError={() => setError(true)}
    />
  )
}

const extToMime = (url) => {
  if (!url) return undefined
  const ext = url.split('?')[0].split('.').pop().toLowerCase()
  switch(ext){
    case 'mp3': return 'audio/mpeg'
    case 'm4a': return 'audio/mp4'
    case 'wav': return 'audio/wav'
    case 'ogg': return 'audio/ogg'
    case 'webm': return 'audio/webm'
    case 'aac': return 'audio/aac'
    default: return undefined
  }
}

export function RemoteAudio({ src, controls = true, loop = false, className, style, onTimeUpdate, onEnded, refElem }){
  let url = normalize(src)
  if (url && url.includes('.r2.cloudflarestorage.com')) {
    const proxyBase = process.env.REACT_APP_API_URL || ''
    url = `${proxyBase.replace(/\/$/, '')}/media/proxy?url=${encodeURIComponent(url)}`
  }

  if (!url) return <div style={{padding:12,color:'#666'}}>Audio not available</div>

  const type = extToMime(url)

  return (
    <audio controls={controls} loop={loop} className={className} style={style} crossOrigin="anonymous" ref={refElem} onTimeUpdate={onTimeUpdate} onEnded={onEnded}>
      <source src={url} {...(type ? {type} : {})} />
      Your browser does not support the audio element.
    </audio>
  )
}

export default normalize
